/**
 * Extends generated reportsApi.ts with non-JSON response handling. The export
 * endpoints return `text/csv`, which the default JSON parser rejects.
 * After regenerating via `pnpm run generate:reports`, verify export endpoint names.
 *
 * RTK Query 1.8 keeps the generated result types for overridden endpoints, so
 * callers of the text endpoints should treat the result as a string.
 */
import {
  type AdminExportReportCsvApiArg,
  type ExportReportApiArg,
  type ExportReportCsvApiArg,
  reportsApi,
} from './reportsApi';

reportsApi.injectEndpoints({
  endpoints: (build) => ({
    adminExportReportCsv: build.mutation<Blob, AdminExportReportCsvApiArg>({
      query: (queryArg) => ({
        url: `/2026-02-24/${queryArg.reportType}/export-csv`,
        method: 'POST',
        body: queryArg.reportExportRequestBodyDto,
        headers: {
          'cs-organization': queryArg['cs-organization'],
        },
        responseHandler: async (response) => response.blob(),
      }),
      invalidatesTags: ['reports-controller'],
    }),
    exportReport: build.mutation<string, ExportReportApiArg>({
      query: (queryArg) => ({
        url: `/2025-10-21/${queryArg.reportType}/export`,
        method: 'POST',
        body: queryArg.reportExportRequestBodyDto,
        headers: {
          'cs-organization': queryArg['cs-organization'],
          'cs-fleet': queryArg['cs-fleet'],
        },
        responseHandler: 'text',
      }),
      invalidatesTags: ['reports-controller'],
    }),
    exportReportCsv: build.mutation<string, ExportReportCsvApiArg>({
      query: (queryArg) => ({
        url: `/2025-10-21/${queryArg.reportType}/export-csv`,
        method: 'POST',
        body: queryArg.reportExportRequestBodyDto,
        headers: {
          'cs-organization': queryArg['cs-organization'],
          'cs-fleet': queryArg['cs-fleet'],
        },
        responseHandler: 'text',
      }),
      invalidatesTags: ['reports-controller'],
    }),
  }),
  overrideExisting: true,
});

export { reportsApi };
